import domready from "domready"
import "./style.css"
import Color from "./Color";


const PHI = (1 + Math.sqrt(5)) / 2;
const TAU = Math.PI * 2;
const DEG2RAD_FACTOR = TAU / 360;

const config = {
    width: 0,
    height: 0
};

/**
 * @type CanvasRenderingContext2D
 */
let ctx;
let canvas;

domready(
    () => {

        canvas = document.getElementById("screen");
        ctx = canvas.getContext("2d");

        const width = (window.innerWidth) | 0;
        const height = (window.innerHeight) | 0;

        config.width = width;
        config.height = height;

        canvas.width = width;
        canvas.height = height;

        const size = Math.max(width/2, height/2);

        const hw = width / 2;
        const hh = height / 2;

        ctx.fillStyle = "#000";
        ctx.fillRect(0, 0, width, height);

        const numBlobs = 600;

        const blobs = [];

        for (let i = 0; i < numBlobs; i++)
        {
            const rnd = Math.random();

            const angle = TAU * Math.random();
            const rnd2 = Math.random()
            const r = size * Math.pow(rnd2, PHI);

            const blobSize = 8 + rnd * rnd * rnd * rnd * size * 0.0002 * r;
            const numPoints = 0 | TAU * blobSize / 200 + 5;

            blobs.push({
                r,
                angle,
                blobSize,
                numPoints
            })
        }

        blobs.sort((a,b) => a.r - b.r)

        for (let i = 0; i < numBlobs; i++)
        {
            const {
                r,
                angle,
                blobSize,
                numPoints
            } = blobs[i];

            const bx = hw + Math.cos(angle) * r;
            const by = hh + Math.sin(angle) * r;

            ctx.fillStyle = Color.fromHSL(Math.random(), 0.6, 0.6).toRGBA(0.8);
            ctx.beginPath();

            let a2 = Math.random() * TAU;
            const aStep = TAU / numPoints;

            for (let i=0; i < numPoints; i++)
            {

                const r = blobSize/2 + Math.random() * blobSize;
                const x = bx + Math.cos(a2) * r;
                const y = by + Math.sin(a2) * r;

                if (i === 0)
                {
                    ctx.moveTo(x,y)
                }
                else
                {
                    ctx.lineTo(x,y)
                }

                a2 += aStep;
            }


            ctx.fill();

        }

    }
);
